import { Stink } from 'components/Stink'
import { ReactNode } from 'react'

export const Lauftext_DE: ReactNode[] = [
  <>
    <p>
      Ob zum Apéro mit Häppchen, zum Mittagessen oder beim
      Über-die-Stränge-Schlagen in geselliger Runde – Alkohol ist in unserer
      Breiten kulturell tief verankert. Archäologen haben herausgefunden, dass
      halbsesshafte Jäger und Sammler bereits vor über 13’000 Jahren Getreide
      gären liessen. Das bislang erste bierartige Getränk Mitteleuropas datiert
      6000 Jahre zurück und wurde an den Ufern von Zürich- und Bodensee
      nachgewiesen.
    </p>
  </>,
  <>
    <p>
      Schweizerinnen und Schweizer sind dem berauschenden Zellgift bis heute
      zugetan. Mengenmässig sind wir dabei eine Biernation. Auf den
      Alkoholgehalt bezogen ist allerdings der Wein Spitzenreiter. Laut der
      Schweizerischen Gesundheitsbefragung trinken 70 Prozent der Männer und 50
      Prozent der Frauen wöchentlich Alkohol. Dass dies zum Problem werden kann,
      ist klar. In der Schweiz wird die Zahl alkoholabhängiger Menschen auf rund
      250’000 geschätzt. Alkoholkonsum verursacht fast jeden zehnten Todesfall.
    </p>
  </>,
  <>
    <p>
      Doch was passiert genau im Körper, wenn wir ein oder mehrere Gläser mit
      Alkohol trinken?
    </p>
  </>,
  <>Aufnahme</>,
  <>
    <h2>Schnell ins Blut</h2>
    <p>
      Noch bevor wir das Getränk geschluckt haben, gelangt ein Teil des Alkohols
      über die Mundschleimhaut und die Schleimhaut der Speiseröhre direkt ins
      Blut. Allerdings nimmt nur ein Bruchteil diesen Weg. Bis zu einem Viertel
      des Alkohols wird über die Magenschleimhaut aufgenommen. Der Hauptteil
      kommt jedoch <b>über den Darm ins Blut</b> – vorwiegend über den oberen
      Dünndarm.
    </p>
  </>,
  <>
    <h2>Beschleuniger im Glas</h2>
    <p>
      Je schneller die Alkoholkonzentration im Blut steigt, desto schneller
      werden wir betrunken.
    </p>
  </>,
  <>
    <p>
      Langsamer steigt der Blutalkoholspiegel hingegen, wenn die{' '}
      <b>Magenentleerung verzögert</b> wird. Denn dann dauert es auch länger,
      bis der Alkohol in den Darm gelangt, wo die Aufnahme am effizientesten
      ist. Ein voller Magen («Bödele») führt deshalb dazu, dass die
      Blutalkoholkonzentration langsamer steigt.
    </p>
  </>,
  <>
    <h2>Verteilung im Körper</h2>
    <p>
      Die maximale Blutalkoholkonzentration wird{' '}
      <b>in der Regel etwa eine Stunde</b> nach der Einnahme erreicht. Danach
      sinkt der Blutspiegel durch Abbau und Ausscheidung – ausser es wird weiter
      neuer Alkohol zugeführt.
    </p>
  </>,
  <>
    <p>
      Mit dem Blut verteilt sich der Alkohol schnell und gleichmässig im ganzen
      Körper. Ein Teil erreicht das Gehirn, wo er am meisten Verwirrung stiftet.
    </p>
  </>,
  <>Wirkung</>,
  <>
    <h2>Konfusion im Gehirn</h2>
    <p>
      Im Gehirn beeinflusst Alkohol die Botenstoffe und damit verschiedene
      Hirnfunktionen. Die Sehleistung verringert sich, das Blickfeld wird
      verengt (Tunnelblick). Aufmerksamkeit, Konzentration, Urteilsfähigkeit und
      Reaktionsvermögen sinken. Im Gegenzug steigt die Risikobereitschaft.
    </p>
    <p>
      Je nach Menge des konsumierten Alkohols können Leistungen leicht bis sehr
      stark eingeschränkt sein. Bei einem Blutalkoholwert von 0,8 Promille ist
      gegenüber dem nüchternen Zustand zum Beispiel{' '}
      <b>die Reaktionszeit um 30 bis 50 Prozent verlängert</b>.
    </p>
    <p>
      Alkohol beeinflusst auch die Emotionen. Anfänglich wirkt er entspannend
      oder euphorisierend. Mit zunehmender Menge kommt es zu negativen Gefühlen
      und unpassendem Verhalten. Dabei spielt die psychische Verfassung eine
      Rolle. Bei Trauer oder Wut kann Alkohol vorübergehend die Laune
      verbessern, später dann aber{' '}
      <b>noch tiefere Traurigkeit und grössere Wut</b> bewirken.
    </p>
  </>,
  <>
    <h2>Frauen, Männer und das Körperfett</h2>
    <p>
      Frauen vertragen Alkohol in der Regel weniger gut als Männer. Das ist
      unter anderem eine{' '}
      <b>Folge ihres durchschnittlich grösseren Körperfettanteils</b>. Alkohol
      löst sich in Wasser besser als in Fett, weshalb bei gleichem Körpergewicht
      und gleicher Konsummenge die Alkoholkonzentration im Blut von Frauen
      üblicherweise höher ist als bei Männern. Zudem verfügen Frauen über
      geringere Mengen der alkoholabbauenden Alkoholdehydrogenase.
    </p>
    <p>
      <b>Jugendliche spüren den Alkohol schneller</b> als Erwachsene. Sie sind
      in der Regel leichter und haben weniger alkoholabbauende Enzyme. Vor allem
      ist ihr wachsender Körper und das sich noch entwickelnde Gehirn anfälliger
      für Schäden. Ältere Erwachsene vertragen Alkohol ebenfalls weniger gut,{' '}
      <b>da der Anteil Körperwasser mit dem Alter wieder abnimmt</b>. Der Körper
      braucht im Alter zudem länger für den Abbau von Alkohol. Auch Medikamente
      und Krankheiten können die Wirkung von Alkohol beeinflussen.
    </p>
    <p>
      Hinzu kommen genetisch bedingte Unterschiede.{' '}
      <b>
        Asiaten haben beispielsweise häufig ein sogenannt atypisches Enzymsystem
      </b>
      , das bewirkt, dass sich das giftige Alkoholabbauprodukt Acetaldehyd
      ansammelt. Der Körper reagiert darauf mit der Erweiterung der Hautgefässe,
      Kopfschmerzen, Übelkeit, Benommenheit, Herzklopfen und erhöhter
      Herzfrequenz.
    </p>
  </>,
  <>
    <h2>Promille berechnen</h2>
    <p>
      Um die Blutalkoholkonzentration in Promille zu berechnen, müssen die Menge
      des konsumierten Alkohols und das Körpergewicht der betreffenden Person
      bekannt sein. Zudem sollte <b>das Geschlecht berücksichtigt</b> werden:
      Bei Männern macht das Körperwasser circa 68 Prozent des Gewichts aus, bei
      Frauen circa 55 Prozent. Bei der Berechnung der Promille wird deshalb eine
      entsprechende Konstante von 0,68 für Männer beziehungsweise 0,55 für
      Frauen angenommen. Ein Standardglas enthält zwischen 10 und 12 Gramm
      reinen Alkohol und entspricht etwa 3 dl Bier, 1 dl Wein oder 2 cl einer
      Spirituose.
    </p>
    <p>Formel:</p>
  </>,
  <>
    <h2>Warum bekommt man einen Kater?</h2>
    <p>
      Am Tag nach der Becherei schlägt der Kater zu. Typisch sind Kopfschmerzen,
      Herzklopfen und Übelkeit. Mögliche Ursachen:
      <ul>
        <li style={{ marginBottom: '15px' }}>
          <b>Wasserentzug:</b> Alkohol führt dazu, dass der Körper zu viel
          Wasser ausscheidet und dehydriert.
        </li>
        <li style={{ marginBottom: '15px' }}>
          <b>Begleitstoffe:</b> Alkoholische Getränke enthalten neben Ethanol
          (Trinkalkohol) oft auch sogenannte höhere Alkohole, Fuselöle und
          andere Substanzen, die einen Kater fördern können.
        </li>
        <li style={{ marginBottom: '15px' }}>
          <b>Schlafrhythmus:</b> Alkohol verkürzt die Traumphasen und verlängert
          die Tiefschlafzeiten. Die veränderte Wärmeregulierung des Körpers kann
          den Schlaf ebenfalls beeinflussen. Am nächsten Tag fühlt man sich
          deshalb oft unwohl und übermüdet, selbst wenn man genügend lange
          geschlafen hat.
        </li>
      </ul>
      <b>Das hilft:</b> Viel Flüssigkeit und Mineralstoffe können den
      Stoffwechsel wieder ins Lot bringen und die Symptome lindern.
      Sauerstoffzufuhr und etwas Bewegung bringen den Kreislauf in Schwung.
    </p>
  </>,
  <>Abbau</>,
  <>
    <h2>Ausscheiden und abbauen</h2>
    <p>
      Nachdem die Alkoholkonzentration im Blut ihr Maximum erreicht hat, sinkt
      der Spiegel mit einer Geschwindigkeit von 0,1 bis 0,15 Promille pro
      Stunde. Rund ein Zehntel des Alkohols wird ausgeschieden – über die
      Lungen, die Nieren und die Haut. Der grosse Rest wird jedoch in der Leber
      abgebaut.
    </p>
  </>,
  <>
    <p>
      Der Alkohol, genau genommen Ethanol, wird in der Leber in zwei Stufen
      mithilfe von Enzymen abgebaut. Den <b>ersten Schritt</b> übernimmt die
      Alkoholdehydrogenase. Es entsteht <b>Acetaldehyd</b>, eine giftige
      Substanz, die bei übermässigem Alkoholkonsum für Schädigungen im ganzen
      Körper verantwortlich ist. Sie greift die Zellmembranen an und wirkt
      hemmend auf Enzymsysteme.
    </p>
  </>,
  <>
    <p>
      <b>Beim zweiten Abbauschritt</b> wird das Acetaldehyd in Acetat
      (Essigsäure) umgebaut. Dies geschieht mithilfe des Enzyms{' '}
      <b>Aldehyddehydrogenase</b>. Acetat wird danach weiter umgewandelt und in
      die Fettsäure- und Cholesterol-Synthese eingeschleust. Wird viel Alkohol
      getrunken, führt dies zu einer Anhäufung von Fettsäuren in der Leber und
      schliesslich zu einer Fettleber.
    </p>
  </>,
  <>
    <h2>Weiteres Enzym bei Gewöhnung </h2>
    <p>
      Bei erhöhtem Alkoholkonsum wird ein weiteres Enzym aktiviert, die
      sogenannte <b>Mischfunktionelle Oxidase</b>. Die geschieht bereits ab
      einer Blutalkoholkonzentration von 0,5 Promille. Das Enzym vermag bis zu
      einem Viertel des Alkohols abzubauen und ist bei Personen, die regelmässig
      viel trinken, in grösserer Menge vorhanden. Der Alkohol wird dadurch
      schneller zu Acetaldehyd abgebaut, weshalb es mehr Alkohol braucht, um
      eine berauschende Wirkung zu erzeugen. Diese Gewöhnung hat aber{' '}
      <b>keinen positiven Einfluss auf die Gesundheit</b>, denn das giftige
      Acetaldehyd wird deswegen nicht schneller abgebaut.
    </p>
  </>,
  <>Folgen</>,
  <>
    <h2>Krank von Kopf bis Fuss</h2>
    <p>
      Neben den sozialen Folgen von Alkoholmissbrauch kann ein jahrelanger,
      übermässiger Konsum praktisch jedes Organ im Körper schädigen. Am
      stärksten betroffen ist die Leber, wo der Alkoholabbau überwiegend
      erfolgt. Dabei werden Zellen geschädigt, und es sammelt sich Fett an. Mit
      der Zeit führt dies zu einer Fettleber und später zu Gelbsucht,
      Leberzirrhose und Leberkrebs. Um ihr{' '}
      <Stink href='313967957581'>Risiko tief zu halten</Stink>, sollten Männer
      nicht mehr als zwei, Frauen nicht mehr als ein Standardglas pro Tag zu
      sich nehmen. Weniger ist noch besser. Für Kinder, Schwangere und Stillende
      wäre es wichtig, ganz auf Alkohol zu verzichten.
    </p>
  </>,
  <>
    <h2>Unfälle und Gewalt</h2>
    <p>
      Übermässiger Alkoholkonsum hat auch Auswirkungen auf Dritte, verursacht
      Leid bei Angehörigen und führt zu Unfällen und Gewalt – zu Hause in der
      Familie wie im öffentlichen Raum. Nicht zuletzt hat Alkoholkonsum
      gefährliche Folgen im Strassenverkehr und gehört dort zu den{' '}
      <b>Hauptursachen für Tote und Schwerverletzte</b>. In der Schweiz darf ab
      0,5 Promille nicht mehr Auto gefahren werden. Es drohen hohe Bussen und ab
      0,8 Promille Führerausweisentzug für mindestens drei Monate. Gar nichts
      trinken dürfen Berufschauffeure und Neulenkende.
    </p>
  </>,
]
